const { getApiLanguage, setApiLanguage } = require('./api/language');
const config = require('./config');
const genres = require('./genres');
const lootcoinBoni = require('./lootcoinBoni');
const lootgemBoni = require('./lootgemBoni');
const adPlacementTypes = require('./adPlacementTypes');
const adRewardTypes = require('./adRewardTypes');
const utils = require('./utils');

module.exports = {
  config,
  genres,
  lootcoinBoni,
  lootgemBoni,
  adPlacementTypes,
  adRewardTypes,
  utils,
  setApiLanguage,
  getApiLanguage,
};
